// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var AppSetup = function AppSetup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#appsetup-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 16.25c0 .52.418.938.938.938H3.27a3.123 3.123 0 0 0 5.96 0h9.833c.519 0 .937-.418.937-.938a.935.935 0 0 0-.937-.937H9.23a3.123 3.123 0 0 0-5.96 0H.938A.935.935 0 0 0 0 16.25m5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M12.5 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-3.125a3.12 3.12 0 0 0-2.98 2.188H.938A.935.935 0 0 0 0 10c0 .52.418.938.938.938h9.832a3.124 3.124 0 0 0 5.96 0h2.332c.52 0 .938-.418.938-.938a.935.935 0 0 0-.937-.937H16.73a3.12 3.12 0 0 0-2.981-2.188M7.5 5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.98-2.187a3.124 3.124 0 0 0-5.96 0H.938A.935.935 0 0 0 0 3.75c0 .52.418.938.938.938H4.52a3.123 3.123 0 0 0 5.96 0h8.583c.519 0 .937-.418.937-.938a.935.935 0 0 0-.937-.937z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "appsetup-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
